import { createGlobalStyle } from 'styled-components';
import '../fonts/fontFaces.css';

const GlobalStyles = createGlobalStyle`

  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
  }

  html {
    font-size: 10px;
    height: 100%;
    -webkit-tap-highlight-color: transparent;
    scroll-behavior: smooth;
  }

  body {
    font-family: 'DIN Pro', sans-serif;
    margin: 0;
    line-height: 1;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  img {
    user-select: none;
  }

  a {
    text-decoration: none;
  }

  strong {
    font-weight: 700;
  }

  `;

export default GlobalStyles;
